import store from "../store";

let client;

const notificationRequests = {
  setClient: (c) => {
    client = c;
  },

  // Helper to get the correct endpoint based on user type
  getEndpoint(path) {
    const userType = store.getters.userType;
    const prefix = userType === 'admin' ? '/admins' : '/clients';
    return `${prefix}/notifications${path}`;
  },

  // Get notifications for current user
  async getNotifications(params = {}) {
    const endpoint = this.getEndpoint('');
    const response = await client.get(endpoint, { params });
    return response.data;
  },

  // Get unread notification count
  async getUnreadCount() {
    const endpoint = this.getEndpoint('/unread-count');
    const response = await client.get(endpoint);
    return response.data;
  },

  // Mark specific notification as read
  async markAsRead(notificationId) {
    const endpoint = this.getEndpoint(`/${notificationId}/read`);
    const response = await client.patch(endpoint);
    return response.data;
  },

  // Mark specific notification as unread
  async markAsUnread(notificationId) {
    const endpoint = this.getEndpoint(`/${notificationId}/unread`);
    const response = await client.patch(endpoint);
    return response.data;
  },

  // Mark all notifications as read
  async markAllAsRead() {
    const endpoint = this.getEndpoint('/mark-all-read');
    const response = await client.patch(endpoint);
    return response.data;
  },

  // Get notification preferences
  async getPreferences() {
    const endpoint = this.getEndpoint('/preferences');
    const response = await client.get(endpoint);
    return response.data;
  },

  // Update notification preferences
  async updatePreferences(preferences) {
    const endpoint = this.getEndpoint('/preferences');
    const response = await client.put(endpoint, { preferences });
    return response.data;
  },

  // Delete a specific notification
  async deleteNotification(notificationId) {
    const endpoint = this.getEndpoint(`/${notificationId}`);
    const response = await client.delete(endpoint);
    return response.data;
  },

  // Delete all notifications for current user
  async deleteAllNotifications() {
    const endpoint = this.getEndpoint('');
    const response = await client.delete(endpoint);
    return response.data;
  }
};

export default notificationRequests;